import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LoginSignup = () => {
  const navigate = useNavigate();

  const [visibleLogin, setVisibleLogin] = useState(false);
  const [visibleSignup, setVisibleSignup] = useState(false);
  const [username, setUsername] = useState(``);
  const [password, setPassword] = useState(``);
  const [usernameSignup, setUsernameSignup] = useState(``);
  const [emailSignup, setEmailSignup] = useState(``);
  const [passwordSignup, setPasswordSignup] = useState(``);

  const clientId = localStorage.getItem("client_id")
  useEffect(() => {
    if(clientId){
      navigate(`/`);
    }
  }, [])

  const handleVisiblePasswordLogin = () => {
    setVisibleLogin(!visibleLogin);
  };

  const handleVisiblePasswordSignup = () => {
    setVisibleSignup(!visibleSignup);
  };

  const handleSignup = () => {
    axios
      .post(`/api/v1/customers`, {
        username: usernameSignup,
        email: emailSignup,
        password: passwordSignup,
      })
      .then((res) => {
        handleLogin(usernameSignup, passwordSignup);
      })
      .catch((err) => console.log(err));
  };

  const handleLogin = (a, b) => {
    axios
      .post(`/api/v1/customers/login`, {
        username: a,
        password: b,
      })
      .then((res) => {
        toast("Đăng nhập thành công!", {
          type: "success",
          autoClose: 1000,
        });
        localStorage.setItem("client_token", res.data.clientToken);
        localStorage.setItem("client_id", res.data.clientId);
        navigate(`/`);
      })
      .catch((err) => {
        toast(err.response.data.message, {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin(username, password);
    }
  };

  return (
    <>
      <div className="login-signup-container mt-4">
        <div className="login-signup-title">Đăng nhập</div>
        <div className="login-signup-layout">
          <div className="login-signup-left">
            <div className="login-title">ĐĂNG NHẬP</div>
            <div className="login-signup-label">
              Tên tài khoản hoặc địa chỉ email<i className="text-danger">*</i>
            </div>
            <div className="login-signup-box">
              <input
                type="text"
                className="login-signup-input"
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="login-signup-label">
              Mật khẩu<i className="text-danger">*</i>
            </div>
            <div className="login-signup-box">
              <input
                type={visibleLogin ? "text" : "password"}
                className="login-signup-input"
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <i
                className={`bi ${visibleLogin ? "bi-eye-slash" : "bi-eye"}`}
                onClick={handleVisiblePasswordLogin}
              ></i>
            </div>
            <div className="remember-password">
              <input type="checkbox" className="me-2" />
              Ghi nhớ mật khẩu
            </div>
            <button
              className="login-signup-button"
              onClick={() => handleLogin(username, password)}
            >
              Đăng nhập
            </button>
            <div className="forgot-password">Quên mật khẩu?</div>
          </div>
          <div className="login-signup-right">
            <div className="login-title">ĐĂNG KÝ</div>
            <div className="login-signup-label">
              Tên tài khoản<i className="text-danger">*</i>
            </div>
            <div className="login-signup-box">
              <input
                type="text"
                className="login-signup-input"
                onChange={(e) => setUsernameSignup(e.target.value)}
              />
            </div>
            <div className="login-signup-label">
              Địa chỉ email<i className="text-danger">*</i>
            </div>
            <div className="login-signup-box">
              <input
                type="text"
                className="login-signup-input"
                onChange={(e) => setEmailSignup(e.target.value)}
              />
            </div>
            <div className="login-signup-label">
              Mật khẩu<i className="text-danger">*</i>
            </div>
            <div className="login-signup-box">
              <input
                type={visibleSignup ? "text" : "password"}
                className="login-signup-input"
                onChange={(e) => setPasswordSignup(e.target.value)}
              />
              <i
                className={`bi ${visibleSignup ? "bi-eye-slash" : "bi-eye"}`}
                onClick={handleVisiblePasswordSignup}
              ></i>
            </div>
            <button className="login-signup-button" onClick={handleSignup}>
              Đăng ký
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginSignup;
